// Constant: Patterns > Email pattern
const EMAIL_PATTERN = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,24}$/

// Export
export {
  EMAIL_PATTERN
}
